import { render, staticRenderFns } from "./ConfigItem.vue?vue&type=template&id=1d690d3b&scoped=true&"
import script from "./ConfigItem.vue?vue&type=script&lang=js&"
export * from "./ConfigItem.vue?vue&type=script&lang=js&"
import style0 from "./ConfigItem.vue?vue&type=style&index=0&id=1d690d3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d690d3b",
  null
  
)

export default component.exports